import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "icon"]

  copy(event) {
    const button = event.currentTarget
    const text = button.dataset.clipboardText

    if (navigator.clipboard && window.isSecureContext) {
      // Use modern clipboard API
      navigator.clipboard.writeText(text).then(() => {
        this.showSuccess(button)
      }).catch(() => {
        this.fallbackCopy(text, button)
      })
    } else {
      // Fallback for older browsers or non-secure contexts
      this.fallbackCopy(text, button)
    }
  }

  fallbackCopy(text, button) {
    // Create temporary textarea
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.left = '-999999px'
    textarea.style.top = '-999999px'
    document.body.appendChild(textarea)

    try {
      textarea.focus()
      textarea.select()
      const successful = document.execCommand('copy')

      if (successful) {
        this.showSuccess(button)
      } else {
        this.showError(button)
      }
    } catch (err) {
      this.showError(button)
    } finally {
      document.body.removeChild(textarea)
    }
  }

  showSuccess(button) {
    if (!button) {
      console.warn('showSuccess called with null button')
      return
    }

    const icon = button.querySelector('i')
    if (!icon) {
      console.warn('No icon found in button:', button)
      return
    }

    const originalClass = icon.className

    // Change to checkmark
    icon.className = 'bi bi-check text-success'

    // Restore original icon after 2 seconds
    setTimeout(() => {
      icon.className = originalClass
    }, 2000)
  }

  showError(button) {
    if (!button) {
      console.warn('showError called with null button')
      return
    }

    const icon = button.querySelector('i')
    if (!icon) {
      console.warn('No icon found in button:', button)
      return
    }

    const originalClass = icon.className

    // Change to error icon
    icon.className = 'bi bi-x text-danger'

    // Restore original icon after 2 seconds
    setTimeout(() => {
      icon.className = originalClass
    }, 2000)
  }
}
